import React from 'react';
import { motion } from 'framer-motion';
import { Plus } from 'lucide-react';
import { extras } from '../data/packages';
export function Extras() {
  return <section className="w-full bg-black py-16 px-4" id="extras" data-id="element-147" data-mp="1hgk5lbcfs97t">
      <div className="max-w-7xl mx-auto" data-id="element-148" data-mp="13m9p1halflcu">
        <div className="relative bg-zinc-900/80 border-2 border-red-600/70 rounded-lg p-5 sm:p-8 md:p-10 lg:p-12 overflow-hidden shadow-[0_0_30px_-5px_rgba(220,38,38,0.2)]" data-id="element-149" data-mp="13l8bn663umry">
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 mb-8 md:mb-10" data-id="element-150" data-mp="tnk57iz4zqty">
            <div className="text-center md:text-left" data-id="element-151" data-mp="yllnw2snho4w">
              <h2 className="text-3xl sm:text-4xl md:text-5xl font-black uppercase text-white mb-3" data-id="element-152" data-mp="kp8i3qxhbb69">
                <span className="text-red-600" data-id="element-153" data-mp="oqjz582aeo2u">Extra</span> Services
              </h2>
              <p className="text-gray-400 text-base sm:text-lg md:text-xl" data-id="element-154" data-mp="2f1yd6bzl2qf8">
                Add these to any package for the ultimate finish
              </p>
            </div>
            <div className="p-4 bg-red-600/10 border border-red-900/50 rounded-lg" data-id="element-155" data-mp="109pjpfv5396y">
              <Plus className="w-9 h-9 text-red-500" aria-hidden="true" data-id="element-156" data-mp="vaw33ekk322k" />
            </div>
          </div>

          <ul className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6" data-id="element-157" data-mp="19zshruh4bdc5">
            {extras.map((extra, index) => <motion.li key={extra.name} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05,
            duration: 0.25
          }} className="flex items-center justify-between gap-4 p-5 md:p-6 bg-black/40 border border-zinc-700 rounded-lg" data-id="element-158" data-mp="1505yb3ap50uw" data-mpi={index}>
                <span className="font-bold text-gray-200 uppercase tracking-wide text-base sm:text-xl min-w-0" data-id="element-159" data-mp="m9eqi66cxiim">
                  {extra.name}
                </span>
                <span className="font-black text-red-500 text-xl sm:text-2xl whitespace-nowrap" data-id="element-160" data-mp="1xpwbna4i7ypy">
                  {extra.price}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}